import { useJsApiLoader } from '@react-google-maps/api'
import { Env, readFromEnv } from '@cinch-nx/environments'

const API_KEY = readFromEnv(Env.GoogleMapsApiKey)

/**
 * Shared Google Maps loader hook that ensures consistent configuration
 * across all components that use Google Maps API.
 *
 * This prevents the "Loader must not be called again with different options" error
 * that occurs when multiple components try to load the Google Maps script with
 * different configurations.
 */
export const useGoogleMapsLoader = () =>
  useJsApiLoader({
    googleMapsApiKey: API_KEY,
  })
